import { styled } from '@mui/material';

import { useI18n } from '@app-velocity/i18n';
import { Page } from '@app-velocity/ui';

import { TopUp } from './components/TopUp';

const StyledSection = styled('section')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(3),
  flexDirection: 'column',
  width: '100%',
}));

const TopUpsContainer = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: theme.spacing(4),
}));

const topUps = [
  { amount: 100, price: 100 },
];

export const TopUps = () => {
  const { t } = useI18n();

  return (
    <StyledSection>
      <Page.SectionHeader title={t('teams:usage.simulations.buy')} />
      <TopUpsContainer>
        {topUps.map((topUp) => (
          <TopUp key={topUp.amount} amount={topUp.amount} price={topUp.price} />
        ))}
      </TopUpsContainer>
    </StyledSection>
  );
};
